import React, { useState } from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, TextField, MessageBar, MessageBarType } from '@fluentui/react';
import PropTypes from 'prop-types';

function ReplaceModal({
  isOpen,
  onDismiss,
  onReplace,
  resourceTypeName,
  findResourceName,
  replaceResourceName,
  title = `Replace ${resourceTypeName}`,
  subText = `This will replace the selected ${resourceTypeName} resource for the selected cobrands.`,
  cobrandNames = [],
  loading = false,
  error = '',
  explainText = ''
}) {
  const [confirmation, setConfirmation] = useState('');
  const [touched, setTouched] = useState(false);

  const handleReplace = () => {
    setTouched(true);
    if (confirmation.trim().toLowerCase() === resourceTypeName.trim().toLowerCase()) {
      onReplace();
      setConfirmation('');
      setTouched(false);
    }
  };

  const handleDismiss = () => {
    setConfirmation('');
    setTouched(false);
    onDismiss();
  };

  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={handleDismiss}
      dialogContentProps={{
        type: DialogType.normal,
        title,
        subText,
      }}
      minWidth={400}
    >
      <div style={{ marginBottom: 12 }}>
        <p><b>Find Resource:</b> {findResourceName || <i>None (will not change for cobrands where not present)</i>}</p>
        <p><b>Replace With:</b> {replaceResourceName}</p>
        <p><b>Cobrands Affected:</b> {cobrandNames.length > 0 ? cobrandNames.join(', ') : <i>None</i>}</p>
        <span style={{ color: '#a00', fontSize: 13 }}>
          {explainText}
        </span>
      </div>
      <TextField
        label={`Type "${resourceTypeName}" to confirm`}
        value={confirmation}
        onChange={(_, v) => setConfirmation(v)}
        onBlur={() => setTouched(true)}
        errorMessage={touched && confirmation.trim().toLowerCase() !== resourceTypeName.trim().toLowerCase() ? `Type "${resourceTypeName}" to confirm.` : ''}
        autoComplete="off"
      />
      {error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}
      <DialogFooter>
        <PrimaryButton
          onClick={handleReplace}
          text={loading ? 'Replacing...' : 'Replace'}
          disabled={loading || confirmation.trim().toLowerCase() !== resourceTypeName.trim().toLowerCase()}
        />
        <DefaultButton onClick={handleDismiss} text="Cancel" disabled={loading} />
      </DialogFooter>
    </Dialog>
  );
}

ReplaceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onReplace: PropTypes.func.isRequired,
  resourceTypeName: PropTypes.string.isRequired,
  findResourceName: PropTypes.string,
  replaceResourceName: PropTypes.string,
  title: PropTypes.string,
  subText: PropTypes.string,
  cobrandNames: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.string,
  explainText: PropTypes.string,
};

export default ReplaceModal;
